import { Action } from '@/_core/fluxstore/types';
import { CurrentWsState } from '../types';
import { useCurrentWsStore } from '../useModule';

const { registerReducer } = useCurrentWsStore();

export class ChangeMemberRole extends Action<CurrentWsState> {
    public static ACTION_TYPE = 'ChangeMemberRole';
    public constructor(public oldRole: number, public newRole: number) {
        super(ChangeMemberRole.ACTION_TYPE);
    }
}

const reducer = (state: CurrentWsState, action: ChangeMemberRole): void => {
    if(action.oldRole === action.newRole) {
        return;
    }

    if(action.oldRole === 0) {
        state.observerCount -= 1;
    } else {
        state.memberCount -= 1;
    }
    
    if(action.newRole === 0) {
        state.observerCount += 1;
    } else {
        state.memberCount += 1;
    }


};

//@ts-ignore
registerReducer(ChangeMemberRole.ACTION_TYPE, reducer);